// extracted by mini-css-extract-plugin
module.exports = {"container":"BasicInput_container__1vGKt Div_Div__38Xlj","marginBottom":"BasicInput_marginBottom__SmwxG","passwordInput":"BasicInput_passwordInput__2p5ZX"};